import Menu from '@material-ui/core/Menu'
import GetApp from '@material-ui/icons/GetApp'
import { IconButton } from 'ignitic/dist/core/icon-button'
import { useUUID } from 'ignitic/dist/hooks/use-uuid'
import { display } from 'ignitic/dist/styles/display'
import { cn } from 'itils/dist/misc/cn'
import * as React from 'react'

type Props = {
  children: React.ReactNode
}

export function DownloadMenu(props: Props) {
  const [open, setOpen] = React.useState(false)
  return <DownloadMenuUncontrolled {...props} open={open} setOpen={setOpen} />
}

export function DownloadMenuUncontrolled(
  props: Props & { open: boolean; setOpen: (open: boolean) => void }
) {
  const ref = React.useRef<HTMLButtonElement>(null)
  const id = useUUID()
  return (
    <React.Fragment>
      <IconButton
        className={cn(display.none, display.sm_inlineFlex)}
        ref={ref}
        aria-label="Sækja"
        aria-owns={props.open ? id : undefined}
        aria-haspopup="true"
        onClick={() => props.setOpen(true)}
      >
        <GetApp />
      </IconButton>
      <Menu
        id={id}
        anchorEl={ref.current}
        open={props.open}
        onClose={() => props.setOpen(false)}
      >
        {props.children}
      </Menu>
    </React.Fragment>
  )
}
